import { countTotalAllDivs } from "./countTotal.js";
import { uuidv4 } from "../global.js";
import { swiper_update_height} from "../sliders/sliders.js";
import { withCsrfToken } from "./csrf.js";

let number_of_items_per_load = 200;
let requests = {};

$('.inventory').on('click', 'button.button-load-ajax.load-inventory', function (e) {
    let $load_button = $(this);
    if ($load_button.data('loading')) {
        return;
    }
    $load_button.data('loading', true);
    if ($load_button.hasClass('animation-loading')) {
        $load_button.addClass('loading');
    }
    if ($load_button.hasClass('hide-loading')) {
        $load_button.hide();
    }
    $load_button.prop('disabled', true);
    let $inventory_wrapper = $load_button.parents('.bet-content-show');
    let url = $inventory_wrapper.data('url');

    let posting = $.post(url, withCsrfToken(url));
    posting.done(function (data) {
        $inventory_wrapper.append(data);
        swiper_update_height();
        countTotalAllDivs();
        $('.empty_placeholder_error_load', $inventory_wrapper).remove();
    });
    posting.fail(function (data) {
        console.log(data);
        $('.empty_placeholder_error_load', $inventory_wrapper).show();
    });
    posting.always(function () {
        if ($load_button.length) {
            $load_button.remove();
        }
    });
})

//initialize inventory preload
$('.inventory_preload[data-url]').each(function () {
    let $inventory_wrapper = $(this);
    preload_inventory($inventory_wrapper);
});

//load more items
$('.inventory_preload[data-url]').on('click', 'button.button-load-ajax', function () {
    let $load_button = $(this);
    let $inventory_wrapper = $load_button.parents('.inventory_preload');
    preload_inventory($inventory_wrapper);
});

//sort inventory
$('.inventory_preload[data-url]').on('inventory:sort', function () {
    let $inventory_wrapper = $(this);
    $inventory_wrapper.find('button.button-load-ajax').remove();
    $inventory_wrapper.find('.pay__item').remove();
    $inventory_wrapper.find('.placeholder-temp').remove();
    $inventory_wrapper.data('start-index', 0);
    countTotalAllDivs();
    $inventory_wrapper.find('.placeholder-container').hide();
    preload_inventory($inventory_wrapper);
});


function preload_inventory ($wrapper) {
    if ($wrapper.data('loading')) {
        requests[$wrapper.data('loading')].abort();
    }
    let request_id = uuidv4();
    $wrapper.data('loading', request_id);
    let $swiper_wrapper = $wrapper.closest('.swiper-slide');
    let $load_button = $wrapper.find('button.button-load-ajax');
    //при догрузке заглушка встала бы строкой сетки над предметами и вытолкнула
    //кнопку за высоту слайда до swiper_update_height, лоад показывает сама кнопка
    if (!$load_button.length) {
        $wrapper.find('.loading_placeholder').show();
    }
    let url = 'https://' + window.location.host + $wrapper.data('url');
    let sort_by_price = $wrapper.data('sort_by_price') || 0;
    let sort_by_discount = $wrapper.data('sort_by_discount') || 0;
    let sort_by_rarity = $wrapper.data('sort_by_rarity') || "Rarity All";
    let sort_by_game = $wrapper.data('sort_by_game') || "Game All";
    let sort_by_name = $wrapper.data('sort_by_name') || "";
    let sort_item_start_index = $wrapper.data('start-index') || 0;
    let items_ids_exclude = [];
    if (sort_item_start_index > 0) {
        $swiper_wrapper.find('.pay__item input[type=checkbox]').each(function () {
            items_ids_exclude.push($(this).val());
        });
    }
    let post_data = {
        sort_by_price: sort_by_price,
        sort_by_discount: sort_by_discount,
        sort_by_rarity: sort_by_rarity,
        sort_by_game: sort_by_game,
        sort_by_name: sort_by_name,
        sort_item_start_index: sort_item_start_index,
        num_of_items_per_load: number_of_items_per_load,
        items_ids_exclude: JSON.stringify(items_ids_exclude)
    };
    let posting = $.post(url, withCsrfToken(url, post_data));
    requests[request_id] = posting;
    posting.done(function (data) {
        if ($load_button.length) {
            $load_button.remove();
            $wrapper.append(data);
        } else {
            $wrapper.find('.pay__item').remove();
            $wrapper.find('.empty_placeholder_error_load').remove();
            $wrapper.find('.empty_placeholder').hide();
            $wrapper.find('.pay__item').remove();
            $wrapper.append(data);
        }
        $wrapper.data('start-index', post_data.sort_item_start_index + post_data.num_of_items_per_load);
        swiper_update_height();
        countTotalAllDivs();
    });
    posting.fail(function (data) {
        console.log(data);
        if (data.statusText === 'abort') {
            return;
        }
        $('.empty_placeholder_error_load', $wrapper).show();
        if ($load_button.length) {
            $load_button.remove();
        }
    });
    posting.always(function () {
        delete requests[request_id];
        $wrapper.data('loading', false);
        $wrapper.find('.loading_placeholder').hide();
    });
}
